import React, { useRef, useEffect, useState } from "react";
import { useReactToPrint } from "react-to-print";
import Icon from "@mdi/react";
import { mdiPrinter, mdiMicrosoftExcel, mdiArrowLeft } from "@mdi/js";
import moment from "moment";

import DatHangDaiLyApi from "../../../../service/datHangDaiLyApi";
import { getUserLogin } from "../../../../utils/utils";
import FullScreenLoading from "component/DanhSachDatHang/loading/FullScreenLoading";

const STATUS_LABEL = { 0: "Chờ báo giá", 1: "Đã báo giá" };

class ComponentToPrint extends React.Component {
  render() {
    const { DataSend = [], tuNgay, denNgay } = this.props;
    return (
      <div
        style={{
          padding: "10px", margin: "5px", backgroundColor: "#ffffff",
          fontSize: "14px", fontFamily: "tahoma", marginBottom: "50px",
        }}
        id="htmlPrint"
      >
        <div id="htmlPrintex">
          <div style={{ textAlign: "center" }}>
            <h3 style={{ marginBottom: "-2px", fontSize: "20px" }}>
              <b>DANH SÁCH BÁO GIÁ</b>
            </h3>
          </div>
          <br />
          <span style={{ marginBottom: "15px" }}>
            <b>
              Từ ngày: {moment(tuNgay).format("DD/MM/YYYY")}
              &nbsp;&nbsp; Đến ngày: {moment(denNgay).format("DD/MM/YYYY")}
            </b>
          </span>
          <table
            style={{ width: "100%", border: "1px solid black", borderCollapse: "collapse", marginTop: 8 }}
          >
            <thead>
              <tr>
                <th style={{ width: "5%",  border: "1px solid black", textAlign: "center", padding: "4px 8px" }}>STT</th>
                <th style={{ border: "1px solid black", textAlign: "left",   padding: "4px 8px" }}>Mã báo giá</th>
                <th style={{ border: "1px solid black", textAlign: "center", padding: "4px 8px" }}>Thời gian</th>
                <th style={{ border: "1px solid black", textAlign: "center", padding: "4px 8px" }}>Trạng thái</th>
              </tr>
            </thead>
            <tbody>
              {DataSend.map((item, i) => (
                <tr key={item.BaoGiaDaiLyID || i}>
                  <td style={{ border: "1px solid black", textAlign: "center", padding: "3px 8px" }}>{i + 1}</td>
                  <td style={{ border: "1px solid black", textAlign: "left",   padding: "3px 8px" }}>{item.MaBaoGia}</td>
                  <td style={{ border: "1px solid black", textAlign: "center", padding: "3px 8px" }}>
                    {item.CreatedTime ? moment(item.CreatedTime).format("DD/MM/YYYY HH:mm:ss") : ""}
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "center", padding: "3px 8px" }}>
                    {STATUS_LABEL[item.Approval] ?? ""}
                  </td>
                </tr>
              ))}
              {!DataSend.length && (
                <tr>
                  <td colSpan={4} style={{ border: "1px solid black", textAlign: "center", padding: "8px" }}>
                    Không có dữ liệu
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div style={{ marginTop: 8, fontSize: 13 }}>
            Tổng số: <b>{DataSend.length}</b> đơn báo giá
          </div>
        </div>
      </div>
    );
  }
}

export const PrintDanhSachBaoGia = () => {
  const params  = new URLSearchParams(window.location.search);
  const tuNgay    = params.get("tuNgay")    || moment().subtract(30, "days").format("YYYY-MM-DD");
  const denNgay   = params.get("denNgay")   || moment().format("YYYY-MM-DD");
  const sMaBaoGia = params.get("sMaBaoGia") || "";

  const [list, setList]       = useState([]);
  const [loading, setLoading] = useState(true);
  const componentRef = useRef();

  useEffect(() => { loadAll(); }, []);

  const loadAll = () => {
    setLoading(true);
    DatHangDaiLyApi.danhSachBaoGiaDaiLy({
      sUserName:  getUserLogin().UserName,
      tuNgay:     tuNgay  + "T00:00:00",
      denNgay:    denNgay + "T23:59:59",
      iPageIndex: 1,
      iPageSize:  100000,
      sMaBaoGia,
    })
      .then((res) => {
        setLoading(false);
        if (res.status === 200) setList(res.data?.List || []);
      })
      .catch(() => setLoading(false));
  };

  const handlePrint = useReactToPrint({ content: () => componentRef.current });

  const xuatExcel = (e) => {
    e.preventDefault();
    const uri = "data:application/vnd.ms-excel," +
      encodeURIComponent(document.getElementById("htmlPrintex").outerHTML);
    const a = document.createElement("a");
    a.href = uri;
    a.download = "DanhSachBaoGia" + moment().format("YYYYMMDDHHmm") + ".xls";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const quayLai = () => { window.location.href = "/DatHangDaiLy?tab=baogiadaily"; };

  return (
    <>
      {loading && <FullScreenLoading />}

      <ComponentToPrint ref={componentRef} DataSend={list} tuNgay={tuNgay} denNgay={denNgay} />

      <div
        className="fixed"
        style={{ width: "100%", left: "0px", paddingRight: "30px" }}
      >
        <div style={{ width: "100%", clear: "both" }}>
          <div style={{ marginTop: "25px", float: "right", display: "flex", gap: 10 }}>
            <button className="button-Icon-text bg-blue-main" onClick={quayLai}>
              <Icon path={mdiArrowLeft} size={1} color="white" />
              &nbsp;Quay lại
            </button>
            <a className="button-Add-NoIcon bg-blue-main" href="#" onClick={xuatExcel}>
              <Icon path={mdiMicrosoftExcel} size={1.4} color="white" />
              &nbsp;Xuất excel
            </a>
            <button className="button-Icon-text bg-blue-main" onClick={handlePrint}>
              <Icon path={mdiPrinter} size={1} color="white" />
              &nbsp;In danh sách
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
